import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import Select from '@mui/material/Select';
import { Box, InputLabel, MenuItem, Typography, FormHelperText, Grow, InputAdornment, } from '@mui/material';
import { Translation } from '../Translation';
import useInputLabelDisplay from '../../hooks/useInputLabelDisplay';
import DropdownSelectLabel from './DropdownSelectLabel';
import dropdownSelectStyles from './dropdownSelect.styles';
const DropdownSelect = ({ id, type, options, classes, showLabel = true, disabled, required, value, errorMessage, label = '', placeholder = '', optionSuffix, inputAdornment, showDefaultValue, defaultValue, ...props }) => {
    const styles = dropdownSelectStyles();
    const inputLabel = useInputLabelDisplay(label);
    const displayedPlaceholder = useInputLabelDisplay(placeholder);
    return (_jsxs(Box, { className: clsx([styles.root, classes?.root]), children: [showLabel !== false && (_jsx(Typography, { variant: 'subtitle1', "data-test": `dropdown_select:label:${id}`, children: _jsx(InputLabel, { className: clsx([styles.label, classes?.label]), htmlFor: id, required: required, classes: {
                        asterisk: clsx([
                            {
                                [styles.labelAsterixHidden]: disabled,
                                ...(classes?.labelAsterixHidden && {
                                    [classes.labelAsterixHidden]: disabled,
                                }),
                            },
                        ]),
                    }, children: inputLabel }, void 0) }, void 0)), _jsxs(Select, { id: id, type: type, fullWidth: true, className: clsx([
                    styles.inputRoot,
                    classes?.inputRoot,
                    {
                        [styles.disabled]: disabled,
                        ...(classes?.disabled && {
                            [classes.disabled]: disabled,
                        }),
                    },
                ]), error: !!errorMessage, disabled: disabled, labelId: id, value: (showDefaultValue ? defaultValue : value) || '-1', variant: "outlined", "data-test": `dropdown_select:${id}`, ...(disabled && {
                    IconComponent: () => null,
                }), classes: {
                    select: clsx([
                        styles.select,
                        classes?.select,
                        {
                            [styles.placeholder]: !value,
                            ...(classes?.placeholder && {
                                [classes.placeholder]: !value,
                            }),
                        },
                    ]),
                    outlined: clsx([styles.outlined, classes?.outlined]),
                    disabled: clsx([styles.disabled, classes?.disabled]),
                }, ...(!!inputAdornment && {
                    startAdornment: (_jsx(InputAdornment, { position: "start", className: clsx([styles.inputAdornment, classes?.inputAdornment]), children: inputAdornment }, void 0)),
                }), MenuProps: {
                    classes: {
                        list: clsx([styles.list, classes?.list]),
                        paper: clsx([styles.listPaper, classes?.listPaper]),
                    },
                }, ...props, children: [_jsx(MenuItem, { value: '-1', disabled: true, classes: {
                            root: clsx([
                                styles.itemDisabled,
                                styles.firstMenuItem,
                                classes?.itemDisabled,
                                classes?.firstMenuItem,
                            ]),
                        }, children: displayedPlaceholder ?? '' }, void 0), options
                        .filter((option) => option.value)
                        .map((option, index) => {
                        return (_jsx(MenuItem, { value: option.value, "data-test": `dropdown_select:option:${option.label}`, classes: {
                                root: clsx([styles.item, classes?.item]),
                            }, children: _jsx(DropdownSelectLabel, { label: option.label, className: clsx([
                                    {
                                        [styles.itemLabel]: option.value !== value,
                                        ...(classes?.itemLabel && {
                                            [classes.itemLabel]: option.value !== value,
                                        }),
                                        [styles.itemSelected]: option.value === value,
                                        ...(classes?.itemSelected && {
                                            [classes.itemSelected]: option.value === value,
                                        }),
                                    },
                                ]), shouldFormatPrice: (showDefaultValue || options.length === 1) &&
                                    type === 'number', suffix: optionSuffix }, void 0) }, index));
                    })] }, void 0), !!errorMessage && (_jsx(Grow, { in: !!errorMessage, easing: '.1s', children: _jsx(FormHelperText, { className: clsx([styles.helper, classes?.helper]), "data-test": `${id}:dropdownSelect:error`, children: _jsx(Translation, { id: errorMessage }, void 0) }, void 0) }, void 0))] }, void 0));
};
export default DropdownSelect;
//# sourceMappingURL=DropdownSelect.js.map